export const columnWidths = {
  dragHandle: { base: '5.4%', md: '7.2%', lg: '5%', xl: '5%' },
  promoBanner: { base: '9%', md: '10.7%', lg: '11.6%', xl: '12.5%' },
  brand: { base: '6.3%', md: '7.2%', lg: '7.6%', xl: '8.1%' },
  mechanism: { base: '8.1%', md: '9.8%', lg: '10.7%', xl: '11.6%' },
  period: { base: '6.3%', md: '7.2%', lg: '12%', xl: '12%' },
  code: { base: '6.3%', md: '7.2%', lg: '8.1%', xl: '9%' },
  type: { base: '6.3%', md: '7.2%', lg: '8.1%', xl: '9%' },
  productHighlight: { base: '7.2%', md: '9%', lg: '9.8%', xl: '10.7%' },
  status: { base: '4%', md: '5%', lg: '6%', xl: '6%' },
  displayInSOL: { base: '6.3%', md: '7.2%', lg: '8.1%', xl: '9%' },
  homeBanner: { base: '6.3%', md: '7.2%', lg: '8.1%', xl: '9%' },
};
